module.exports = __webpack_public_path__ + "img/honda-Used.d77bbcfc.png";